/**
 * For super-over innings (5, 6, 7, 8, ...), set label to "inn s1", "inn s2", etc.:
 */
export const normalizeInningsLabels = (data) => {
  if (!data?.innings || !Array.isArray(data.innings)) return;
  data.innings.forEach((inn) => {
    const num = parseInt(inn.innings_number, 10);
    if (num >= 5) {
      const segment = Math.ceil((num - 4) / 2);
      inn.label = `${inn.label.split(' ')[0]} inn s${segment}`;
    }
  });
};

const getInningsData = (data, inningsSelected) => {
  if (!inningsSelected || !data?.innings) return null;
  normalizeInningsLabels(data);
  const inningsData = data.innings.find((el) => {
    return el.innings_number === inningsSelected.toString();
  });
  return inningsData;
};

export default getInningsData;
